const semver = require('semver');

module.exports = semver.satisfies(process.version, '>=15.7.0');



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonwebtoken/lib/asymmetricKeyDetailsSupported.js
// module id = 531
// module chunks = 1